export const createAbogadosTeamLink = (simulationId) => {
  return `${process.env.REACT_APP_ABOGADOS_FRONTEND_BASE_API_URL}/CreateTeamPreamble?simulationId=${simulationId}`;
};

export const createCreambowTeamLink = (simulationId) => {
  return `${process.env.REACT_APP_CREAMBOW_FRONTEND_BASE_API_URL}/CreateTeamPreamble?simulationId=${simulationId}`;
};
